export default "__VITE_ASSET__CT0ldanS__"